import { ChangeEvent } from 'react';
import { Controller, FieldValues, Path } from 'react-hook-form';
import { TextField } from '@mui/material';
import { FormFieldProps } from 'src/distribution_platforms/features/order_form';

export const PatientIdField = <T extends FieldValues>({
  control,
  errors,
  onChange,
}: FormFieldProps<T> & {
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
}) => (
  <Controller
    name={'externalId' as Path<T>}
    control={control}
    render={({ field }) => (
      <TextField
        required
        label='Patient ID'
        data-testid='patient-id-field'
        {...field}
        error={!!errors.externalId}
        helperText={errors.externalId?.message?.toString() ?? ' '}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          field.onChange(e);
          onChange?.(e);
        }}
      />
    )}
  />
);
